import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { isNullOrUndefined } from 'util';
import { LAND_SUBSIDENCE_LEGEND_LIST, LAND_SUBSIDENCE_LAYER_LIST, LOCATION_HIE } from './land-subsidence-map-constants';
import { AgricultureMapConstants, LAYER_TYPES } from 'src/app/main/constants/dims-map-constants';
import { HttpClient } from '@angular/common/http';
import { LandSubsidenceDashboardService } from '../land-subsidence-dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class LandSubsidenceMapService {
  gisMapComp: any;
  selectedLocType: any;

  private mlMap: any = null;
  private mlProtocolRegistered = false;
  private leafletMapRef: any = null;
  private leafletMoveHandler: any = null;
  private leafletClickHandler: any = null;
  private leafletZoomAnimHandler: any = null;
  private leafletZoomEndHandler: any = null;
  private isZoomAnimating = false;
  private previousZoom = 0;
  private rafId: any = null;
  private mlSourceDataHandler: any = null;
  private timeSteps: string[] = [];
  private currentDate: string = null;
  private popupMoveHandler: any = null;
  private popupLatLng: any = null;
  private readonly PMTILES_URL = 'https://metwise.vassarlabs.com/pmtiles/buildings_timeseries_20260623_with_mean_velocity.pmtiles';

  constructor(
    private http: HttpClient,
    private landSubsidenceDashSrv: LandSubsidenceDashboardService
  ) { }

  resetSessionState() {
    this.selectedLocType = null;
  }

  async getSrcWiseLayers(gisMapComp: any) {
    gisMapComp.legendList = {};
    gisMapComp.showThrobber = true;
    let queryParams: any = gisMapComp['params'];
    // gisMapComp.getAndSetBaseLayers();
    gisMapComp.map.closePopup();
    this.removeCustomPopup();
    setTimeout(() => {
      gisMapComp.map.setView([17.3850, 78.4867], 15)
    }, 2000)
    if (!isNullOrUndefined(queryParams) && Object.keys(queryParams).length > 0) {
      let layerList: any = {};
      let layerName: any;
      let hie = LOCATION_HIE;
      layerName = queryParams.locType != 'BLOCK'
        ? gisMapComp.gisUtils.titleCase(hie[hie.indexOf(queryParams.locType) + 1])
        : gisMapComp.gisUtils.titleCase(queryParams.locType);
      layerList[layerName + ' Boundary'] = LAND_SUBSIDENCE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary'];
      // layerList[layerName + ' Boundary Labels'] = LAND_SUBSIDENCE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][layerName + ' Boundary Labels'];
      // if (queryParams.locType != 'COUNTRY') {
      //   layerList[gisMapComp.gisUtils.titleCase(queryParams.locType)] = LAND_SUBSIDENCE_LAYER_LIST[AgricultureMapConstants.LOCATIONS.INDIA][gisMapComp.gisUtils.titleCase(queryParams.locType) + ' Boundaries'];
      // }

      // layerList = gisMapComp.gisdataService.addMaskLayer(layerList, queryParams, gisMapComp.params.component);
      // this.addSrcWiseGeoJSONLayers(gisMapComp, queryParams, layerList);
      this.addSrcWiseVectorLayers(layerList, gisMapComp, queryParams);
      // this.addSrcWiseWMSLayers(layerList, gisMapComp, queryParams);
      this.addLegend(gisMapComp);
      this.initMapLibreOverlay(gisMapComp);

      // gisMapComp.otherOptions['onLocationClick'] = queryParams.locType == 'BLOCK' ? false : true;
      gisMapComp.showThrobber = false;
    }
  }

  private initMapLibreOverlay(gisMapComp: any) {
    const maplibregl: any = (window as any).maplibregl;
    const pmtiles: any = (window as any).pmtiles;
    if (!maplibregl || !pmtiles) return;

    this.destroyMapLibreOverlay();

    const mapContainer = document.getElementById(gisMapComp.mapId) as HTMLElement;
    if (!mapContainer) return;

    if (window.getComputedStyle(mapContainer).position === 'static') {
      mapContainer.style.position = 'relative';
    }

    const overlay = document.createElement('div');
    overlay.id = 'ls-maplibre-container';
    overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;';
    mapContainer.appendChild(overlay);

    // .leaflet-control-container has no z-index of its own, so the overlay's z-index:10
    // beats it in the stacking order even though .leaflet-top/.leaflet-bottom are z-index:1000.
    // Fix: re-append the control container AFTER the overlay (so it's last in the DOM),
    // give it an explicit z-index above the overlay, and force a GPU compositor layer.
    // const leafletControlContainer = mapContainer.querySelector('.leaflet-control-container') as HTMLElement;
    // if (leafletControlContainer) {
    //   mapContainer.appendChild(leafletControlContainer);
    //   leafletControlContainer.style.zIndex = '1010';
    //   leafletControlContainer.style.transform = 'translateZ(0)';
    // }

    if (!this.mlProtocolRegistered) {
      const protocol = new pmtiles.Protocol();
      maplibregl.addProtocol('pmtiles', protocol.tile.bind(protocol));
      const p = new pmtiles.PMTiles(this.PMTILES_URL);
      protocol.add(p);
      this.mlProtocolRegistered = true;
    }

    this.leafletMapRef = gisMapComp.map;
    const center = this.leafletMapRef.getCenter();
    this.previousZoom = this.leafletMapRef.getZoom();

    this.mlMap = new maplibregl.Map({
      container: overlay,
      style: 'https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json',//{ version: 8, sources: {}, layers: [] },
      center: center,
      zoom: this.previousZoom,
    });

    this.mlMap.on('load', () => {
      if (!this.mlMap) return;
      this.mlMap.addSource('ls_buildings', {
        type: 'vector',
        url: `pmtiles://${this.PMTILES_URL}`,
        minzoom: 0,
        maxzoom: 15
      });
      this.mlMap.addLayer({
        id: 'ls-buildings-layer',
        type: 'fill',
        source: 'ls_buildings',
        'source-layer': 'buildings',
        paint: {
          'fill-color': '#ffffbf',
          'fill-opacity': 0.6,
          'fill-outline-color': 'rgba(255,255,255,0.08)'
        }
      });

      // Dates aren't known ahead of time; discover them from the first rendered
      // features' property keys (YYYY-MM-DD), same as the reference implementation.
      this.mlSourceDataHandler = (e: any) => {
        if (!this.mlMap || e.sourceId !== 'ls_buildings' || !this.mlMap.isSourceLoaded('ls_buildings')) return;
        const features = this.mlMap.queryRenderedFeatures({ layers: ['ls-buildings-layer'] });
        if (features.length === 0) return;

        this.mlMap.off('sourcedata', this.mlSourceDataHandler);
        this.mlSourceDataHandler = null;

        const sampleProperties = features[0].properties;
        this.timeSteps = Object.keys(sampleProperties)
          .filter((key: string) => /^\d{4}-\d{2}-\d{2}$/.test(key))
          .sort();

        if (this.timeSteps.length > 0) {
          this.currentDate = this.timeSteps[this.timeSteps.length - 1];
          this.applyThreeColorStyle(this.currentDate);
          this.addSubsidenceSlider(gisMapComp.mapId);
        }
      };
      this.mlMap.on('sourcedata', this.mlSourceDataHandler);
    });

    // Pan sync: batched in rAF, skipped during zoom animation
    this.leafletMoveHandler = () => {
      if (!this.mlMap || !this.leafletMapRef || this.isZoomAnimating) return;
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        // Re-check inside rAF: a zoom may have started since the move fired
        if (!this.mlMap || !this.leafletMapRef || this.isZoomAnimating) return;
        const c = this.leafletMapRef.getCenter();
        this.mlMap.jumpTo({ center: [c.lng, c.lat], zoom: this.leafletMapRef.getZoom() - 1 });
      });
    };
    this.leafletMapRef.on('move', this.leafletMoveHandler);

    // On zoom start: cancel any pending pan rAF, then let MapLibreGL animate
    // natively via easeTo — same mechanism the standalone HTML uses, keeps
    // polygons locked to geographic coordinates throughout the animation.
    this.leafletZoomAnimHandler = (e: any) => {
      this.isZoomAnimating = true;
      if (this.rafId) { cancelAnimationFrame(this.rafId); this.rafId = null; }
      if (!this.mlMap) return;
      const newCenter = e.center as L.LatLng;
      this.mlMap.easeTo({
        center: [newCenter.lng, newCenter.lat],
        zoom: e.zoom - 1,
        duration: 250,
        easing: (t: number) => t
      });
    };
    this.leafletMapRef.on('zoomanim', this.leafletZoomAnimHandler);

    // After zoom ends: clear flag, snap to exact final position
    this.leafletZoomEndHandler = () => {
      this.isZoomAnimating = false;
      if (this.mlMap && this.leafletMapRef) {
        const c = this.leafletMapRef.getCenter();
        this.previousZoom = this.leafletMapRef.getZoom();
        this.mlMap.jumpTo({ center: [c.lng, c.lat], zoom: this.previousZoom - 1 });
        this.mlMap.resize();
      }
    };
    this.leafletMapRef.on('zoomend', this.leafletZoomEndHandler);

    this.leafletClickHandler = (e: any) => {
      if (!this.mlMap) return;
      try {
        const mlPoint = this.mlMap.project([e.latlng.lng, e.latlng.lat]);
        // Leaflet's click latlng and MapLibre's own camera are only approximately
        // synced (integer zoom-1 offset, per-frame jumpTo/easeTo), so there's a
        // small pixel drift between the two. Building footprints are tiny on
        // screen, so an exact single-point hit test very often misses them
        // entirely. Query a small box around the point instead.
        const buffer = 4;
        const features = this.mlMap.queryRenderedFeatures(
          [[mlPoint.x - buffer, mlPoint.y - buffer], [mlPoint.x + buffer, mlPoint.y + buffer]],
          { layers: ['ls-buildings-layer'] }
        );
        if (features.length > 0) {
          gisMapComp.map.setView(e.latlng, 18)
          this.showBuildingPopup(gisMapComp, e.latlng, features[0].properties);
        }
      } catch (err) {
        console.warn('Land subsidence: building hit-test failed', err);
      }
    };
    this.leafletMapRef.on('click', this.leafletClickHandler);

    this.addSubsidenceSlider(gisMapComp.mapId);
  }

  private applyDateStyle(date: string) {
    if (!this.mlMap || !this.mlMap.isStyleLoaded()) return;
    this.mlMap.setPaintProperty('ls-buildings-layer', 'fill-color', [
      'interpolate', ['linear'], ['get', date],
      -10, '#d73027',
      0, '#ffffbf',
      10, '#1a9850'
    ]);
    this.mlMap.setPaintProperty('ls-buildings-layer', 'fill-opacity', 0.85);
  }

  // Discrete 3-bucket version of applyDateStyle: value < -2 -> red,
  // -2 <= value < 2 -> ivory, value >= 2 -> green. Uses MapLibre's 'step'
  // expression instead of 'interpolate', so buildings only ever get one of
  // these three exact colors (no in-between gradient shades).
  private applyThreeColorStyle(date: string) {
    if (!this.mlMap || !this.mlMap.isStyleLoaded()) return;
    this.mlMap.setPaintProperty('ls-buildings-layer', 'fill-color', [
      'step', ['get', date],
      '#d73027',
      -2, '#ffffbf',
      2, '#1a9850'
    ]);
    this.mlMap.setPaintProperty('ls-buildings-layer', 'fill-opacity', 0.85);
  }

  // Leaflet's popup pane is pinned to z-index:1 by a project-wide global rule
  // (`body .leaflet-pane { z-index: 1 !important; }` in _globel.scss, which
  // out-specificities the app's own `.leaflet-popup-pane { z-index: 9999 }`
  // attempt). That traps native L.popup() content behind our MapLibre overlay
  // (z-index:10), which itself must stay above Leaflet's base tile pane to
  // show the colored buildings. Since both constraints can't be satisfied by
  // a popup nested inside Leaflet's pane stack, render our own popup as a
  // plain sibling div instead — the same DOM tier the (working) slider uses.
  private removeCustomPopup() {
    const existing = document.getElementById('ls-custom-popup');
    if (existing) existing.remove();
    if (this.leafletMapRef && this.popupMoveHandler) {
      try {
        this.leafletMapRef.off('move', this.popupMoveHandler);
        this.leafletMapRef.off('zoom', this.popupMoveHandler);
      } catch (e) { }
    }
    this.popupMoveHandler = null;
    this.popupLatLng = null;
  }

  private positionCustomPopup(gisMapComp: any, popupEl: HTMLElement) {
    if (!this.popupLatLng) return;
    const point = gisMapComp.map.latLngToContainerPoint(this.popupLatLng);
    popupEl.style.left = `${point.x}px`;
    popupEl.style.top = `${point.y}px`;
  }

  private showBuildingPopup(gisMapComp: any, latlng: any, props: any) {
    // Fall back to the clicked feature's own date-shaped keys if the one-shot
    // global discovery (in initMapLibreOverlay) hasn't run/found any yet, so a
    // click always opens a popup instead of silently no-oping.
    const featureDates = Object.keys(props)
      .filter((key: string) => /^\d{4}-\d{2}-\d{2}$/.test(key))
      .sort();
    const dates = this.timeSteps.length > 0 ? this.timeSteps : featureDates;
    if (dates.length === 0) return;

    const mapContainer = document.getElementById(gisMapComp.mapId) as HTMLElement;
    if (!mapContainer) return;

    const currentDate = this.currentDate || dates[dates.length - 1];
    const currentValue = parseFloat(props[currentDate]);
    const chartId = `ls-chart-${Date.now()}`;

    const labels: string[] = [];
    const values: number[] = [];
    dates.forEach((dateKey: string) => {
      const val = parseFloat(props[dateKey]);
      if (!isNaN(val)) { labels.push(dateKey); values.push(val); }
    });
    const color = isNaN(currentValue) ? '#888' : (currentValue < 0 ? '#d73027' : '#1a9850');

    this.removeCustomPopup();
    this.popupLatLng = latlng;

    const popupEl = document.createElement('div');
    popupEl.id = 'ls-custom-popup';
    popupEl.style.cssText = [
      'position:absolute', 'z-index:1002', 'transform:translate(-50%, calc(-100% - 12px))',
      'background:#fff', 'color:#222', 'border-radius:8px',
      'box-shadow:0 6px 20px rgba(0,0,0,0.35)', 'padding:12px 14px', 'width:340px',
      'font-family:sans-serif', 'pointer-events:auto'
    ].join(';');
    popupEl.innerHTML = `
      <button id="ls-popup-close" style="position:absolute;top:6px;right:8px;border:none;background:none;font-size:16px;cursor:pointer;color:#666;line-height:1;padding:0;">&times;</button>
      <div style="margin-bottom:10px;font-size:14px;padding-right:16px;">
        <b>Building ID:</b> ${props.building_id || props.fid || 'N/A'}<br>
        <b>Value on ${currentDate}:</b>
        <span style="font-weight:bold;color:${color};">
          ${isNaN(currentValue) ? 'No Data' : currentValue.toFixed(2) + ' mm'}
        </span>
      </div>
      <canvas id="${chartId}" width="320" height="200"></canvas>
    `;
    mapContainer.appendChild(popupEl);
    this.positionCustomPopup(gisMapComp, popupEl);

    popupEl.querySelector('#ls-popup-close').addEventListener('click', () => this.removeCustomPopup());
    popupEl.addEventListener('mousedown', (e: MouseEvent) => e.stopPropagation());
    popupEl.addEventListener('touchstart', (e: TouchEvent) => e.stopPropagation());

    this.popupMoveHandler = () => this.positionCustomPopup(gisMapComp, popupEl);
    gisMapComp.map.on('move', this.popupMoveHandler);
    gisMapComp.map.on('zoom', this.popupMoveHandler);

    setTimeout(() => {
      const canvas = document.getElementById(chartId) as HTMLCanvasElement;
      const ChartLib = (window as any).Chart;
      if (!canvas || !ChartLib || values.length === 0) return;

      const numericX = labels.map((_, idx) => idx);
      const n = values.length;
      let sx = 0, sx2 = 0, sx3 = 0, sx4 = 0, sy = 0, sxy = 0, sx2y = 0;
      for (let i = 0; i < n; i++) {
        const xi = numericX[i], yi = values[i];
        sx += xi; sx2 += xi ** 2; sx3 += xi ** 3; sx4 += xi ** 4;
        sy += yi; sxy += xi * yi; sx2y += (xi ** 2) * yi;
      }

      const solve = (A: number[][], B: number[]) => {
        const M = A.map((r, i) => [...r, B[i]]);
        for (let i = 0; i < 3; i++) {
          let pivot = i;
          for (let j = i + 1; j < 3; j++) if (Math.abs(M[j][i]) > Math.abs(M[pivot][i])) pivot = j;
          [M[i], M[pivot]] = [M[pivot], M[i]];
          const div = M[i][i];
          if (div === 0) return [0, 0, 0];
          for (let j = i; j <= 3; j++) M[i][j] /= div;
          for (let j = 0; j < 3; j++) {
            if (j !== i) {
              const sub = M[j][i];
              for (let k = i; k <= 3; k++) M[j][k] -= sub * M[i][k];
            }
          }
        }
        return [M[0][3], M[1][3], M[2][3]];
      };

      const coeffs = solve([[n, sx, sx2], [sx, sx2, sx3], [sx2, sx3, sx4]], [sy, sxy, sx2y]);
      const [c, b, a] = coeffs;
      const polyValues = numericX.map(v => a * v * v + b * v + c);
      const trendColor = b < 0 ? '#d73027' : '#1a9850';

      // Fixed swatch colors independent of dataset styling, so the legend
      // can't influence (or be influenced by) how the trend line itself is
      // drawn/colored above.
      const legendLabelOptions = {
        usePointStyle: true,
        pointStyle: 'circle',
        boxWidth: 8,
        boxHeight: 8,
        padding: 12,
        font: { size: 12 },
        fontSize: 12,
        generateLabels: () => [
          { text: 'Observed', fillStyle: '#00d4ff', strokeStyle: '#00d4ff', pointStyle: 'circle', datasetIndex: 0 },
          { text: 'Trend', fillStyle: trendColor, strokeStyle: trendColor, pointStyle: 'circle', datasetIndex: 1 }
        ]
      };

      new ChartLib(canvas.getContext('2d'), {
        // Both datasets use the 'line' controller on a shared category (date) x-axis.
        // Mixing in a 'scatter' dataset here breaks Chart.js, since scatter expects
        // numeric {x,y} points and conflicts with the string date labels/category scale.
        type: 'line',
        data: {
          labels,
          datasets: [
            { label: 'Observed', data: values, showLine: false, pointRadius: 3, pointBackgroundColor: '#00d4ff', borderColor: '#00d4ff' },
            { label: 'Trend', data: polyValues, borderColor: trendColor, borderWidth: 2, pointRadius: 0, tension: 0.4 }
          ]
        },
        options: {
          responsive: false,
          // Chart.js v3/v4 reads legend config from options.plugins.legend;
          // Chart.js v2 reads it from options.legend directly and ignores
          // "plugins" entirely. Setting both covers either runtime version.
          legend: { display: true, labels: legendLabelOptions },
          plugins: { legend: { display: true, labels: legendLabelOptions } },
          scales: {
            x: { title: { display: true, text: 'Acquisition Date' } },
            y: { title: { display: true, text: 'Displacement (mm)' } }
          }
        }
      });
    }, 200);
  }

  private addSubsidenceSlider(mapId: string) {
    const mapContainer = document.getElementById(mapId) as HTMLElement;
    if (!mapContainer || this.timeSteps.length === 0) return;

    const existingSlider = document.getElementById('ls-slider-ui');
    if (existingSlider) existingSlider.remove();

    const lastIndex = this.timeSteps.length - 1;

    const sliderDiv = document.createElement('div');
    sliderDiv.id = 'ls-slider-ui';
    sliderDiv.style.cssText = [
      'position:absolute', 'bottom:30px', 'left:50%', 'transform:translateX(-50%)',
      'width:90%', 'max-width:500px', 'z-index:1001',
      'background:rgba(15,15,15,0.95)', 'color:white', 'padding:15px 20px',
      'border-radius:15px', 'border:1px solid #333',
      'box-shadow:0 10px 30px rgba(0,0,0,0.6)', 'pointer-events:auto'
    ].join(';');

    sliderDiv.innerHTML = `
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;">
        <span style="font-size:14px;">Subsidence Timeline</span>
        <span id="ls-step-label" style="font-size:1.1rem;font-weight:bold;color:#00d4ff;">${this.currentDate}</span>
      </div>
      <input id="ls-timeslider" type="range" min="0" max="${lastIndex}" step="1" value="${lastIndex}"
        style="width:100%;cursor:pointer;accent-color:#00d4ff;">
    `;
    mapContainer.appendChild(sliderDiv);

    const slider = sliderDiv.querySelector('#ls-timeslider') as HTMLInputElement;
    const label = sliderDiv.querySelector('#ls-step-label') as HTMLElement;

    slider.addEventListener('input', (e: any) => {
      const index = parseInt(e.target.value, 10);
      const chosenDate = this.timeSteps[index];
      this.currentDate = chosenDate;
      label.innerText = chosenDate;
      this.applyThreeColorStyle(chosenDate);
    });

    sliderDiv.addEventListener('mousedown', (e: MouseEvent) => e.stopPropagation());
    sliderDiv.addEventListener('touchstart', (e: TouchEvent) => e.stopPropagation());
  }

  private destroyMapLibreOverlay() {
    if (this.rafId) { cancelAnimationFrame(this.rafId); this.rafId = null; }

    const existingOverlay = document.getElementById('ls-maplibre-container');
    if (existingOverlay) existingOverlay.remove();
    const existingSlider = document.getElementById('ls-slider-ui');
    if (existingSlider) existingSlider.remove();
    this.removeCustomPopup();

    if (this.mlMap) {
      if (this.mlSourceDataHandler) {
        try { this.mlMap.off('sourcedata', this.mlSourceDataHandler); } catch (e) { }
        this.mlSourceDataHandler = null;
      }
      try { this.mlMap.remove(); } catch (e) { }
      this.mlMap = null;
    }

    this.timeSteps = [];
    this.currentDate = null;

    if (this.leafletMapRef) {
      try {
        if (this.leafletMoveHandler) this.leafletMapRef.off('move', this.leafletMoveHandler);
        if (this.leafletZoomAnimHandler) this.leafletMapRef.off('zoomanim', this.leafletZoomAnimHandler);
        if (this.leafletZoomEndHandler) this.leafletMapRef.off('zoomend', this.leafletZoomEndHandler);
        if (this.leafletClickHandler) this.leafletMapRef.off('click', this.leafletClickHandler);
      } catch (e) { }
      this.leafletMoveHandler = null;
      this.leafletZoomAnimHandler = null;
      this.leafletZoomEndHandler = null;
      this.leafletClickHandler = null;
      this.isZoomAnimating = false;
    }
  }

  addSrcWiseGeoJSONLayers(gisMapComp: any, queryParams: any, layerList: any) {
    if (this.selectedLocType == queryParams.locType) return;
    this.selectedLocType = queryParams.locType;
    let geoJsonLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.GEOJSON_LAYER);
    geoJsonLayersBasedOnView = this.formatLayersData(gisMapComp, geoJsonLayersBasedOnView);
    gisMapComp.addSrcWiseGEOJSONLayers(geoJsonLayersBasedOnView);
  }

  formatLayersData(gisMapComp: any, layerList: any) {
    for (let layerName in layerList) {
      if (layerList[layerName].layerOptions.cql_filter_value) {
        layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + gisMapComp.params['pUUID'] + "'";
      }
    }
    return layerList;
  }

  async addSrcWiseVectorLayers(layerList: any, gisMapComp: any, queryParams: any) {
    let vectorLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.VECTOR_LAYER);
    vectorLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, vectorLayersBasedOnView);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        vectorLayersBasedOnView = this.formatVectorLayersData(vectorLayersBasedOnView, queryParams, gisMapComp);
      }
    }
    this.setVectorLayerStyles(vectorLayersBasedOnView, gisMapComp);
    gisMapComp.addSrcWiseVECTORLayers(vectorLayersBasedOnView);
  }

  formatVectorLayersData(layerList: any, queryParams?: any, gisMapComp?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        let uuid: any = queryParams['pUUID'];
        if (queryParams.locType == 'COUNTRY' && layerName == 'State Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null;
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams.locType == 'COUNTRY' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = null;
          layerList[layerName].layerOptions.cql_filter = '1=1';
        }
        if (queryParams['locType'] == 'STATE' && layerName == 'District Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'state_uuid';
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'DISTRICT' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'dist_uuid';
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
        if (queryParams['locType'] == 'BLOCK' && layerName == 'Block Boundary') {
          layerList[layerName].layerOptions.cql_filter_value = 'uuid';
          layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + uuid + "'";
        }
      }
      return layerList;
    }
  }

  setVectorLayerStyles(layerList: any, gisMapComp: any) {
    for (let key in layerList) {
      let layerName = layerList[key]['layerOptions']['layerName'].split(':')[1];
      layerList[key].layerOptions.vectorTileLayerStyles[layerName] = function (properties: any) {
        let levelBoundary = gisMapComp.gisUtils.titleCase(gisMapComp.params.locType) + ' Boundaries';
        gisMapComp.map.eachLayer((layer: any) => {
          if (layer.options.layer_name === levelBoundary) {
            if (gisMapComp.map.hasLayer(layer)) {
              gisMapComp.map.removeLayer(layer);
            }
          }
        });
        return {
          color: '#000000',
          fill: false,
          weight: gisMapComp.params.locType == 'COUNTRY' ? 0.8 : 0.3,
          opacity: 0.8,
          fillColor: 'transparent',
          fillOpacity: 0.5
        };
      };
    }
  }

  async addSrcWiseWMSLayers(layerList: any, gisMapComp: any, queryParams: any) {
    let wmsLayersBasedOnView = gisMapComp.gisdataService.getApplicationBasedLayer(layerList, LAYER_TYPES.WMS_LAYER);
    wmsLayersBasedOnView = this.addSourceWiseLayers(gisMapComp, wmsLayersBasedOnView);
    for (let layer in layerList) {
      if (layerList[layer].applycql_filter) {
        wmsLayersBasedOnView = this.formatWmsLayersData(wmsLayersBasedOnView, queryParams);
      }
    }
    gisMapComp.addSrcWiseWMSLayers(wmsLayersBasedOnView);
  }

  addSourceWiseLayers(gisMapComp: any, layerList?: any) {
    let layers: any = {};
    for (var i in layerList) {
      layers[i] = layerList[i];
      gisMapComp.activeLayers[i] = layerList[i].layerOptions.visible;
    }
    return layers;
  }

  formatWmsLayersData(layerList: any, queryParams?: any) {
    if (!isNullOrUndefined(queryParams)) {
      for (let layerName in layerList) {
        let uuid: any = queryParams.pUUID;
        if (queryParams.locType == 'STATE') {
          let allLocations = queryParams.location.split('&');
          let stateUUID = allLocations[1].split('##')[1];
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + stateUUID + "'";
          }
        }
        if (queryParams.locType == 'DISTRICT') {
          let allLocations = queryParams.location.split('&');
          let districtUUID = allLocations[2].split('##')[1];
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + districtUUID + "'";
          }
        }
        if (queryParams.locType == 'BLOCK') {
          let allLocations = queryParams.location.split('&');
          let districtUUID = allLocations[3].split('##')[1];
          if (layerList[layerName].layerOptions.cql_filter_value) {
            layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + districtUUID + "'";
          }
          if (layerName == 'Block Boundary Labels') {
            if (layerList[layerName].layerOptions.cql_filter_value) {
              layerList[layerName].layerOptions.cql_filter_value = 'uuid';
              layerList[layerName].layerOptions.cql_filter = layerList[layerName].layerOptions.cql_filter_value + "='" + queryParams.pUUID + "'";
            }
          }
        }
      }
      return layerList;
    }
  }

  addLegend(gisMapComp: any) {
    const legendSrc = LAND_SUBSIDENCE_LEGEND_LIST[AgricultureMapConstants.LOCATIONS.INDIA];
    for (const key in legendSrc) {
      gisMapComp['legendList'][key] = legendSrc[key];
    }
    gisMapComp.manageLegend();
  }

  handleAdminPolygons(layer: any, mapObj: any, params: any, gisMapComp: any) {
    layer.setStyle({ color: '#000', fill: false, weight: 1.5 });
  }
}
